import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-general-leasing',
  templateUrl: './general-leasing.component.html',
  styleUrls: ['./general-leasing.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GeneralLeasingComponent implements OnInit {
  @Input() toolTipList: any;
  toolTipPostion = 'above';
  @Input() matterLeasingForm: FormGroup;
  @Input() testBool;
  constructor(private datepipe: DatePipe) {}

  ngOnInit() {}
  CommanDatePickerClick(type: string, event: MatDatepickerInputEvent<Date>, formControlVar) {
    this.matterLeasingForm.controls[formControlVar].setValue(
      this.datepipe.transform(event.value, 'dd/MM/yyyy'),
    );
  }
  myFunction(event: any) {
    // var copyText: any = document.getElementById("myInput");
    // copyText.select();
    // copyText.setSelectionRange(0,9999);
    // navigator.clipboard.writeText(copyText.value)
    // var copyText: any = document.getElementById("myInput");
    // event.select();
    // event.setSelectionRange(0,9999);
    navigator.clipboard.writeText(event);
  }
}
